import React from 'react'
import injectSheet from 'react-jss'
import {
  AdminNodeListItem,
  AdminNodeDetail,
  ContentContainer,
} from '../../'

class AdminNodeContainer extends React.Component {
  constructor() {
    super()

    this.state = {
      open: true,
    }
  }

  render() {
    const {
      classes,
      config,
      rootNode,
      data,
    } = this.props

    const { open } = this.state

    return (
      <ContentContainer admin>
        <div className={`${classes.container}`}>
          <div className={`${classes.navContainer} ${open && 'open'}`}>
            <ul>
              {data && data.loading && <p>Loading...</p>}
              {data && data.error && <p>Error :(</p>}
              {data && !data.loading && !data.error && (
                <AdminNodeListItem
                  config={config}
                  id={rootNode.id}
                  nodes={data.nodes}
                  level={0}
                />
              )}
            </ul>
          </div>
          <div className={`${classes.detailContainer}`}>
            <AdminNodeDetail nodes={data.nodes} />
          </div>
        </div>
      </ContentContainer>
    )
  }
}

const styles = theme => ({
  container: {
    width: '100%',
    display: 'flex',
  },
  navContainer: {
    width: '40%',
    height: `calc(-${theme.sizes.header + 5}px + 100vh)`,
    [theme.media.medium]: {
      height: `calc(-${theme.sizes.headerLarge + 20}px + 100vh)`,
    },
    overflowY: 'scroll',
    overflowX: 'hidden',
    paddingRight: `${theme.sizes.gutter / 2}px`,
    '& ul': {
      listStyleType: 'none',
      marginLeft: '15px',
      padding: 0,
    },
  },
  detailContainer: {
    width: '60%',
    height: `calc(-${theme.sizes.header + 5}px + 100vh)`,
    [theme.media.medium]: {
      height: `calc(-${theme.sizes.headerLarge + 20}px + 100vh)`,
    },
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
})


export default injectSheet(styles)(AdminNodeContainer)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminNodeContainer.jsx